import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { getQRCode, postVerifyQrCode } from "../../services/mfaServices";
import { handleErrors } from "../../services/handleErrors";
import { BlurSpinner } from "../BlurSpinner";
import "./styles.css";
import { Label, SubLabel, SubTitle, Title, Input } from "./styles";
import { SpinnerButtonPrimary } from "../../ui/buttons";

function QRCodeModal({ toggle, isOpen, handleNextModal, userName, setBackupCode, password }) {
  const [qrBase64, setQrBase64] = useState();
  const [manualCode, setManualCode] = useState();
  const [incorrectToken, setIncorrectToken] = useState(false);
  const [loadingQR, setLoadingQR] = useState(false);

  const formik = useFormik({
    initialValues: {
      token: "",
    },
    onSubmit: async (values) => {
      const { token } = values;
      try {
        const res = await postVerifyQrCode(token.replace(/\s/g, ""), userName, password);

        if (res.success === true) {
          handleNextModal();
          // toggle();
          toast.success("Autenticación de dos factores habilitada");
        } else if (res.success === false) {
          toast.error("código incorrecto");
          setIncorrectToken(true);
        }
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      token: Yup.string().required("Este campo es requerido."),
    }),
  });

  const tokenError = () => {
    let error = "";
    if (incorrectToken) {
      error = "El código de autenticación no coincide";
    }
    if (formik.errors.token) {
      error = formik.errors.token;
    }
    return error;
  };
  const messageError = tokenError();
  const code = async () => {
    setLoadingQR(true);
    const res = await getQRCode({ userName, password });
    setQrBase64(res.codigoQr);
    setManualCode(res.key.replace(/(.{4})/g, "$1 "));
    setBackupCode(res.backupCode);
    setLoadingQR(false);
  };

  useEffect(() => {
    // valida que lleguen los parametros para poder llamar a la funcion que trae el QR
    if (userName !== null && password !== null) {
      code();
    }
  }, [userName || password]);

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} centered contentClassName="custom-modal">
        <form className="theme-form" onSubmit={formik.handleSubmit}>
          <ModalHeader className="border-0 pb-2 p-0" toggle={toggle} />
          <ModalBody className="py-0 px-1">
            <>
              <div className="mb-4">
                <Title>Habilitar autenticación de dos factores</Title>
                <SubTitle>Escanear el código QR</SubTitle>
              </div>

              <div className="pb-4 pt-0 w-100 h-100">
                <div className="p-2 d-flex justify-content-between align-items-center " style={{ borderRadius: "8px", background: "#F7F7F7", height: "fit-content" }}>
                  <div style={{ width: "106px", height: "fit-content" }}>
                    <BlurSpinner loading={loadingQR}>
                      <img style={{ width: "106px", height: "106px", border: "1px solid #C4C4C4" }} src={qrBase64} alt="QRCode" />
                      <p className="text-center mb-0" style={{ fontSize: "10px" }}>
                        {manualCode}
                      </p>
                    </BlurSpinner>
                  </div>
                  <SubLabel style={{ width: "60%", height: "fit-content" }}>
                    Abre la aplicación de autenticación y escanea la imagen a tu izquierda mediante la cámara de tu teléfono.
                  </SubLabel>
                </div>
                <div className="mt-3">
                  <Label>Código</Label>
                  <Input
                    className={formik.errors.email && formik.touched.email ? "form-control error-field" : "form-control"}
                    name="token"
                    placeholder="Ingresa tu código"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.token}
                  />
                  {messageError && formik.touched.token && <div className="input-feedback">{messageError}</div>}
                </div>
              </div>
            </>
          </ModalBody>
          <ModalFooter className="border-0 pt-0">
            <Button color="btn-secondary mr-2" style={{ height: "40px" }} onClick={toggle}>
              Cancelar
            </Button>
            <SpinnerButtonPrimary marginRight="0px" disabled={formik.isSubmitting} isLoading={formik.isSubmitting} type="submit">
              Verificar
            </SpinnerButtonPrimary>
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
}

export default QRCodeModal;
